import React from 'react';
import Footer from 'containers/footer';
import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';
import {useDataValue} from 'globals/contexts/dataContext';

import './legalPage.css';

const LegalPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const logoUrl = content['logo'];

  const pageContent = content['content'][currentLanguage]['legal'];
  return <div id="legal" className="page">
    <div className="landing">
      <div className="logo">
        <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
          <img src={logoUrl} />
        </Link>
      </div>
    </div>
    <section class="legalTerms" dangerouslySetInnerHTML={{
      __html: pageContent
    }} />
    <Footer />
  </div>;
}
export default LegalPage;